import React from "react";

export const PageHeader = ({ eyebrow, title, subtitle, actions, testid }) => (
  <div className="flex items-start justify-between mb-7" data-testid={testid}>
    <div>
      {eyebrow && <div className="eyebrow mb-1">{eyebrow}</div>}
      <h1 className="text-3xl font-semibold tracking-tight text-brand-text">{title}</h1>
      {subtitle && <p className="text-sm text-brand-muted mt-1.5 max-w-2xl">{subtitle}</p>}
    </div>
    {actions && <div className="flex gap-2 shrink-0">{actions}</div>}
  </div>
);

export const StatusPill = ({ status }) => {
  if (!status) return <span className="status-pill status-draft">—</span>;
  const cls = `status-pill status-${status.toLowerCase().replace(/[^a-z_]/g, "_")}`;
  return <span className={cls}>{status.replace(/_/g, " ")}</span>;
};

export const KpiCard = ({ icon: Icon, label, value, hint, accent = false, testid }) => (
  <div className="kpi-card lift" data-testid={testid}>
    <div className="flex items-center justify-between mb-3">
      <div className="eyebrow">{label}</div>
      {Icon && (
        <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${accent ? "bg-brand-teal" : "bg-brand-bg"}`}>
          <Icon className={`w-4 h-4 ${accent ? "text-white" : "text-brand-primary"}`} strokeWidth={1.6} />
        </div>
      )}
    </div>
    <div className="text-3xl font-semibold tracking-tight text-brand-text" data-testid={testid ? `${testid}-value` : undefined}>{value}</div>
    {hint && <div className="text-xs text-brand-muted mt-1.5">{hint}</div>}
  </div>
);

export const SectionCard = ({ title, subtitle, actions, children, testid }) => (
  <div className="section-card" data-testid={testid}>
    {(title || actions) && (
      <div className="flex items-center justify-between mb-4">
        <div>
          {title && <h3 className="text-base font-semibold text-brand-text">{title}</h3>}
          {subtitle && <p className="text-xs text-brand-muted mt-0.5">{subtitle}</p>}
        </div>
        {actions}
      </div>
    )}
    {children}
  </div>
);

export const Loading = ({ label = "Loading…" }) => (
  <div className="flex items-center justify-center py-12 text-sm text-brand-muted" data-testid="loading">
    <div className="animate-pulse">{label}</div>
  </div>
);

export const EmptyState = ({ icon: Icon, title, hint }) => (
  <div className="flex flex-col items-center justify-center py-12 text-center" data-testid="empty-state">
    {Icon && <Icon className="w-8 h-8 text-brand-muted mb-3" strokeWidth={1.4} />}
    <div className="text-sm font-medium text-brand-text">{title}</div>
    {hint && <div className="text-xs text-brand-muted mt-1 max-w-sm">{hint}</div>}
  </div>
);

export const RiskBadge = ({ risk }) => (
  <span className={`status-pill risk-${(risk||"low").toLowerCase()}`}>{risk}</span>
);
